import KeenSlider from 'keen-slider'

class WlKeenSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const sliderElement = this
    const isAutoplay = this.hasAttribute('autoplay')
    const pauseOnMouseEnter = this.hasAttribute('autoplay-pause-on-mouse-enter')
    const soundToggle = document.querySelector('[data-sound-toggle]')

    soundToggle && soundToggle.addEventListener('click', () => {
      const activeSlide = this.querySelector('.keen-slider__slide.is-active')
      if (activeSlide) {
        const video = activeSlide.querySelector('video')
        if (video) {
          video.muted = !video.muted
          video.volume = video.muted ? 0 : 1
          soundToggle.classList.toggle('is-not-muted', !video.muted)
        }
      }
    })

    function WheelControls(slider) {
      let touchTimeout
      let position = {}
      let wheelActive

      function dispatch(e, name) {
        position.x -= e.deltaX
        position.y -= e.deltaY
        slider.container.dispatchEvent(
          new CustomEvent(name, {
            detail: {
              x: position.x,
              y: position.y,
            },
          })
        )
      }

      function wheelStart(e) {
        position = {
          x: e.pageX,
          y: e.pageY,
        }
        dispatch(e, "ksDragStart")
      }

      function wheel(e) {
        dispatch(e, "ksDrag")
      }

      function wheelEnd(e) {
        dispatch(e, "ksDragEnd")
      }

      function eventWheel(e) {


        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
          e.preventDefault()
          if (!wheelActive) {
            wheelStart(e)
            wheelActive = true
          }
        }
        wheel(e)
        clearTimeout(touchTimeout)
        touchTimeout = setTimeout(() => {
          wheelActive = false
          wheelEnd(e)
        }, 50)
      }

      slider.on("created", () => {
        slider.container.addEventListener("wheel", eventWheel, {
          passive: false,
        })
      })
    }

    function autoplay(slider) {
      if (!isAutoplay) {
        return
      }

      let timeout
      let mouseOver = false

      function clearNextTimeout() {
        clearTimeout(timeout)
      }

      function nextTimeout() {
        clearTimeout(timeout)
        if (mouseOver) return
        timeout = setTimeout(() => {
          slider.next()
        }, 4000)
      }

      slider.on("created", () => {
        if (pauseOnMouseEnter) {
          slider.container.addEventListener("mouseover", () => {
            mouseOver = true
            clearNextTimeout()
          })
          slider.container.addEventListener("mouseout", () => {
            mouseOver = false
            nextTimeout()
          })
        }
        nextTimeout()
      })

      slider.on("dragStarted", clearNextTimeout)
      slider.on("animationEnded", nextTimeout)
      slider.on("updated", nextTimeout)
    }

    function navigation(slider) {
      if (!slider.slides.length || slider.slides.length === 1) return

      let wrapper, dots, arrowLeft, arrowRight

      function markup(remove) {
        wrapperMarkup(remove)
        dotMarkup(remove)
        arrowMarkup(remove)
      }

      function removeElement(elment) {
        elment.parentNode.removeChild(elment)
      }

      function createDiv(className) {
        let div = document.createElement("div")
        let classNames = className.split(" ")
        classNames.forEach((name) => div.classList.add(name))
        return div
      }

      function arrowMarkup(remove) {
        if (remove) {
          removeElement(arrowLeft)
          removeElement(arrowRight)
          return
        }
        arrowLeft = createDiv("arrow is-left")
        arrowLeft.addEventListener("click", () => slider.prev())
        arrowRight = createDiv("arrow is-right")
        arrowRight.addEventListener("click", () => slider.next())

        wrapper.appendChild(arrowLeft)
        wrapper.appendChild(arrowRight)
      }

      function wrapperMarkup(remove) {
        if (remove) {
          let parent = wrapper.parentNode
          while (wrapper.firstChild)
            parent.insertBefore(wrapper.firstChild, wrapper)
          removeElement(wrapper)
          return
        }
        wrapper = createDiv("navigation-wrapper")
        slider.container.parentNode.appendChild(wrapper)
        wrapper.appendChild(slider.container)
      }

      function dotMarkup(remove) {
        if (remove) {
          removeElement(dots)
          return
        }
        dots = createDiv("dots")
        slider.track.details.slides.forEach((_e, idx) => {
          let dot = createDiv("dot")
          dot.addEventListener("click", () => slider.moveToIdx(idx))
          dots.appendChild(dot)
        })
        wrapper.appendChild(dots)
      }

      function updateClasses() {
        let slide = slider.track.details.rel
        slide === 0
          ? arrowLeft.classList.add("is-disabled")
          : arrowLeft.classList.remove("is-disabled")
        slide === slider.track.details.slides.length - 1
          ? arrowRight.classList.add("is-disabled")
          : arrowRight.classList.remove("is-disabled")
        Array.from(dots.children).forEach(function (dot, idx) {
          idx === slide
            ? dot.classList.add("is-active")
            : dot.classList.remove("is-active")
        })

        const activeSlide = sliderElement.querySelector('.keen-slider__slide.is-active')
        if (activeSlide) {
          const video = activeSlide.querySelector('video')
          if (video) {
            video.muted = !video.muted
            video.volume = video.muted ? 0 : 1
            soundToggle.classList.toggle('is-not-muted', !video.muted)
          }
        }

        Array.from(slider.slides).forEach((slide, idx) => {
          if (idx === slider.track.details.rel) {
            slide.classList.add('is-active')
          } else {
            slide.classList.remove('is-active')
          }
        })
      }

      slider.on("created", () => {
        markup()
        updateClasses()
      })
      slider.on("optionsChanged", () => {
        markup(true)
        markup()
        updateClasses()
      })
      slider.on("slideChanged", () => {
        updateClasses()
      })
      slider.on("destroyed", () => {
        markup(true)
      })
    }

    const isSingle = this.hasAttribute('single')
    const isAutoWidth = this.hasAttribute('auto')

    new KeenSlider(this.querySelector('.keen-slider'), {
      loop: true,
      rtl: false,
      mode: "snap",
      slides: {
        origin: "auto",
        perView: isAutoWidth ? 'auto' : isSingle ? 1 : 1.3,
        spacing: isAutoWidth ? 5 : isSingle ? 0 : 15,
      },
      breakpoints: isSingle || isAutoWidth ? {} : {
        '(min-width: 500px)': {
          slides: {
            origin: "center",
            perView: 2,
            spacing: 15,
          },
        },
        '(min-width: 768px)': {
          slides: {
            origin: "center",
            perView: 3.3,
            spacing: 15,
          },
        },
        '(min-width: 1200px)': {
          slides: {
            origin: "center",
            perView: 4.3,
            spacing: 15,
          },
        },
      },
    }, [navigation, autoplay, WheelControls])
  }

  disconnectedCallback() {
  }
}

customElements.define('keen-slider', WlKeenSlider);
